// Marks for slider
const emailTemplateMarks = [
  {
    value: 1,
    label: 'Paranoid'
  },
  {
    value: 2,
    label: 'Basic'
  },
  {
    value: 3,
    label: 'Full'
  }
];

export default emailTemplateMarks;
